import React, {useEffect} from 'react';

import Video from '../../../../components/Video/Video';

const PairingGuideVideo = (props) => {
    const {content, index, src, thumbnailSrc, isVideoPaused, children} = props || {};

    let req;
    const currentContent = content[index];
    const {videoStartTime, videoStopTime, isControlsAvailable} = currentContent || {};

    const videoRef = React.createRef();

    let isRequestAnimationFrameAllowed = true;

    useEffect(() => {
        handleVideoUpdate();
    }, [videoRef]);

    //TODO: isVideoPaused check
    useEffect(() => {
        if (isVideoPaused) {
            videoRef.current.pause();
        }
    }, [isVideoPaused]);

    useEffect(() => {
        if (videoRef.current) {
            onLoadedData();
        }

        return () => {
            cancelAnimationFrame(req);
        };
    }, [index, videoRef.current]);

    const onLoadedData = () => {
        videoRef.current.currentTime = videoStartTime;
        videoRef.current.play().catch(() => {});

        handleVideoUpdate(index);
    };

    const handleVideoUpdate = () => {
        if (isRequestAnimationFrameAllowed) {
            const video = videoRef.current;

            if (videoRef.current) {
                if (video.currentTime >= videoStopTime) {
                    video.pause();
                } else {
                    video.play().catch(() => {});
                    req = requestAnimationFrame(() => handleVideoUpdate());
                }
            }
        }
    };

    const videoOnCanPlay = () => handleVideoUpdate();

    const onControlsClick = () => {
        cancelAnimationFrame(req);
        const video = videoRef.current;

        if (video.paused) {
            if (video.currentTime >= videoStopTime) {
                video.currentTime = videoStartTime;
            }
            isRequestAnimationFrameAllowed = true;
            req = requestAnimationFrame(() => handleVideoUpdate());
        } else {
            video.pause();
            isRequestAnimationFrameAllowed = false;
        }
    };

    return (
        <Video
            autoplay
            className='absolute left-[50%]  top-[50%] z-[1] h-full w-full translate-x-[-50%] translate-y-[-50%]'
            controlsClassName='z-[2] rtl:right-[4%] rtl:md:right-[20%] rtl:lg:right-[38%]'
            isControlsVisible={isControlsAvailable}
            muted
            onCanPlay={videoOnCanPlay}
            onControlsClickCustom={onControlsClick}
            playsinline
            thumbnailSrc={thumbnailSrc}
            ref={videoRef}
            src={src}
        >
            {children}
        </Video>
    );
};

export default PairingGuideVideo;
